(function () {
  'use strict';

  var SCROLL_TOP  = 10;   // px — treat as "at top"
  var HIDE_AFTER  = 80;   // px — don't hide until scrolled past this
  var MOBILE_BP   = 750;  // px — matches Dawn/Shopify breakpoint

  var ticking     = false;
  var lastScrollY = window.scrollY;

  var header = document.querySelector('.jk-header');
  if (!header) return;
  if (header.dataset.scrollState === 'false') return;

  /* Lazy stickyGroup: resolved on first use to avoid race with StickyHeader CE.
     Falls back to .section-header if closest() returns null at init time. */
  var _stickyGroup = null;
  function getStickyGroup() {
    if (!_stickyGroup) {
      _stickyGroup = header.closest('.shopify-section-header-sticky') ||
                     document.querySelector('.section-header');
    }
    return _stickyGroup;
  }

  /* ── Detect open overlays ───────────────────────────────────── */
  function isInteractionActive() {
    if (document.querySelector('#Details-menu-drawer-container[open]')) return true;
    if (document.querySelector('details-modal[open]')) return true;
    if (document.body.className.indexOf('overflow-hidden') > -1) return true;
    var el = document.activeElement;
    if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT')) return true;
    return false;
  }

  function showHeader() {
    header.classList.remove('is-hidden');
    var sg = getStickyGroup();
    if (sg) sg.style.top = '';
  }

  function hideHeader() {
    header.classList.add('is-hidden');
    var sg = getStickyGroup();
    if (sg) sg.style.top = '-' + sg.offsetHeight + 'px';
  }

  /* ── Main update ────────────────────────────────────────────── */
  function update() {
    var y      = window.scrollY;
    var delta  = y - lastScrollY;
    var mobile = window.innerWidth < MOBILE_BP;

    /* is-scrolled: both platforms, drives color transition */
    if (y > SCROLL_TOP) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

    if (mobile) {
      if (y <= SCROLL_TOP) {
        /* Back at top → fully restore */
        showHeader();
      } else if (!isInteractionActive()) {
        if (delta > 0 && y > HIDE_AFTER) {
          /* Scrolling down past threshold → hide */
          hideHeader();
        } else if (delta < 0) {
          /* Scrolling up → show immediately */
          showHeader();
        }
      }
    } else {
      /* Desktop: always visible, never hide */
      showHeader();
    }

    lastScrollY = y;
    ticking = false;
  }

  /* ── Listeners ──────────────────────────────────────────────── */
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  /* Switching from mobile to desktop: clear hiding */
  window.addEventListener('resize', function () {
    if (window.innerWidth >= MOBILE_BP) {
      showHeader();
    }
  }, { passive: true });

  /* Set initial state on load */
  update();
})();

/* ── Teleport #menu-drawer to <body> ────────────────────────────────────
   position:fixed inside a position:sticky ancestor doesn't anchor to the
   viewport in Chrome / Safari (compositing-layer containing-block bug).
   Moving the drawer to <body> guarantees top:0 = viewport top and
   z-index:100 beats the header group's z-index:3/4 in the root context. */
(function () {
  'use strict';

  var drawer  = document.getElementById('menu-drawer');
  var details = document.getElementById('Details-menu-drawer-container');
  if (!drawer || !details) return;

  document.body.appendChild(drawer);

  /* Sync open/close classes — replaces Dawn's
     "details[open].menu-opening > .menu-drawer" CSS selector */
  function syncState(mutations) {
    var isOpen    = details.hasAttribute('open');
    var isOpening = isOpen && details.classList.contains('menu-opening');

    drawer.classList.toggle('jk-drawer-open',    isOpen);
    drawer.classList.toggle('jk-drawer-opening', isOpening);

    /* On close: reset inner submenu state that Dawn normally handles via
       mainDetailsToggle.querySelectorAll('details') — now unreachable */
    if (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'open' && !isOpen) {
          drawer.querySelectorAll('details').forEach(function (d) {
            d.removeAttribute('open');
            d.classList.remove('menu-opening');
          });
          drawer.querySelectorAll('.submenu-open').forEach(function (s) {
            s.classList.remove('submenu-open');
          });
        }
      }
    }
  }

  new MutationObserver(syncState).observe(details, {
    attributes:      true,
    attributeFilter: ['open', 'class']
  });

  /* Prevent header-drawer's onFocusOut from closing the drawer when
     keyboard focus moves into the teleported content (capture fires
     before the bubble-phase listener Dawn already attached) */
  var hd = document.querySelector('header-drawer');
  if (hd) {
    hd.addEventListener('focusout', function (e) {
      if (e.relatedTarget && drawer.contains(e.relatedTarget)) {
        e.stopImmediatePropagation();
      }
    }, true);
  }

  /* Escape key: close drawer when focus is inside the teleported content */
  document.addEventListener('keyup', function (e) {
    var key = e.key || e.code;
    if ((key === 'Escape' || key === 'Esc') && details.hasAttribute('open')) {
      var summary = details.querySelector('summary');
      if (summary) summary.click();
    }
  });
})();

/* ── Desktop Navigation Drawer ──────────────────────────────────────────
   Triggered by buttons with data-jk-desktop-drawer-trigger="[handle]".
   Each handle maps to a pre-rendered panel inside #jk-desktop-nav-drawer.
   Desktop-only (≥ 990px). ESC, overlay click, and close button all close. */
(function () {
  'use strict';

  var DESKTOP_BP  = 990;
  var drawer      = document.getElementById('jk-desktop-nav-drawer');
  var closeBtn    = document.getElementById('jk-desktop-nav-drawer-close');
  var drawerInner = drawer ? drawer.querySelector('.jk-desktop-nav-drawer__inner') : null;

  if (!drawer) return;

  var triggers      = document.querySelectorAll('[data-jk-desktop-drawer-trigger]');
  var panels        = drawer.querySelectorAll('[data-jk-drawer-panel]');
  var activeTrigger = null;

  /* ── Panel management ── */
  function showPanel(handle) {
    closeAllSubs();
    panels.forEach(function (p) {
      if (p.dataset.jkDrawerPanel === handle) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  /* ── Open ── */
  function openDrawer(trigger, handle) {
    activeTrigger = trigger;
    showPanel(handle);
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    trigger.setAttribute('aria-expanded', 'true');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    /* Focus after visibility becomes active (two rAF = after paint) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    });
  }

  /* ── Zwei-Ebenen-Submenus (Briefing 17.08.2026) ── */
  function closeAllSubs() {
    drawer.querySelectorAll('[data-jk-sub].is-sub-open').forEach(function (sub) {
      sub.classList.remove('is-sub-open');
    });
    drawer.querySelectorAll('[data-jk-sub-open][aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function openSub(btn) {
    var sub = btn.nextElementSibling;
    if (!sub || !sub.hasAttribute('data-jk-sub')) return;
    closeAllSubs();
    btn.setAttribute('aria-expanded', 'true');
    sub.classList.add('is-sub-open');
    var back = sub.querySelector('[data-jk-sub-back]');
    /* preventScroll: focus waehrend der Slide-Transition scrollte den
       overflow-Container horizontal mit (scrollLeft 269, Befund 17.08.2026) */
    if (back) back.focus({ preventScroll: true });
  }

  function closeSub(sub) {
    sub.classList.remove('is-sub-open');
    var btn = sub.previousElementSibling;
    if (btn && btn.hasAttribute('data-jk-sub-open')) {
      btn.setAttribute('aria-expanded', 'false');
      btn.focus({ preventScroll: true });
    }
  }

  /* ── Close ── */
  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    closeAllSubs();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    var prev = activeTrigger;
    activeTrigger = null;
    if (prev) prev.focus();
  }

  /* ── Trigger clicks ── */
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      if (window.innerWidth < DESKTOP_BP) return;
      var handle = trigger.dataset.jkDesktopDrawerTrigger;
      if (drawer.classList.contains('is-open') && activeTrigger === trigger) {
        closeDrawer();
      } else {
        openDrawer(trigger, handle);
      }
    });
  });

  /* ── Close button ── */
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  /* ── Submenu-Delegation: Open / Back / Sub-X ── */
  if (drawerInner) {
    drawerInner.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-jk-sub-open]');
      if (openBtn) { openSub(openBtn); return; }
      var backBtn = e.target.closest('[data-jk-sub-back]');
      if (backBtn) { closeSub(backBtn.closest('[data-jk-sub]')); return; }
      var subClose = e.target.closest('[data-jk-drawer-close]');
      if (subClose) { closeDrawer(); }
    });
  }

  /* ── Fokus-Falle: Tab bleibt im offenen Drawer (verifiziert 17.08.2026:
     Dawn liefert hier nichts — der Drawer ist teleportiertes Eigen-Markup) ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open') || !drawerInner) return;
    var focusables = drawerInner.querySelectorAll('a[href], button:not([disabled])');
    var visible = Array.prototype.filter.call(focusables, function (el) {
      return el.offsetParent !== null || el.getClientRects().length > 0;
    });
    if (!visible.length) return;
    var first = visible[0];
    var last  = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    } else if (!drawerInner.contains(document.activeElement)) {
      e.preventDefault(); first.focus();
    }
  });

  /* ── Click outside panel closes drawer ── */
  drawer.addEventListener('click', function (e) {
    if (drawerInner && !drawerInner.contains(e.target)) {
      closeDrawer();
    }
  });

  /* ── ESC key ── */
  document.addEventListener('keydown', function (e) {
    var key = e.key || e.code;
    if ((key === 'Escape' || key === 'Esc') && drawer.classList.contains('is-open')) {
      e.preventDefault();
      var openSubEl = drawer.querySelector('[data-jk-sub].is-sub-open');
      if (openSubEl) { closeSub(openSubEl); return; }
      closeDrawer();
    }
  });

  /* ── Resize: close below desktop breakpoint ── */
  window.addEventListener('resize', function () {
    if (window.innerWidth < DESKTOP_BP && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  }, { passive: true });
})();

/* ── Scheme-aware transparent header ────────────────────────────────────
   When the first section on a page template is a pull-under hero, swap
   the header's transparent variant to match the hero colour scheme:
     dark / green hero  → jk-header--transparent-light (white elements)
     light / white hero → jk-header--transparent-dark  (dark elements)
   Guard: only runs if the header already carries a transparent class —
   pages with a solid header are unaffected.
   Note: runs at defer time; a brief FOUC (wrong icon colour) is possible
   before the swap fires. Background is transparent in both variants so
   there is no background flash. Trade-off documented in audit/findings.md. */
(function () {
  'use strict';
  var hero = document.querySelector(
    '#MainContent > .shopify-section:first-of-type .jk-hero--pull-up'
  );
  var header = document.querySelector('.jk-header');
  if (!hero || !header) return;
  if (!header.classList.contains('jk-header--transparent-light') &&
      !header.classList.contains('jk-header--transparent-dark')) return;
  var scheme     = hero.getAttribute('data-jk-scheme');
  var wantLight  = scheme === 'dark' || scheme === 'green';
  header.classList.toggle('jk-header--transparent-light',  wantLight);
  header.classList.toggle('jk-header--transparent-dark',  !wantLight);
})();
